module.exports = __webpack_public_path__ + "static/media/S11.5ffe7b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/S11.png
// module id = 132
// module chunks = 0